import { applyMiddleware, compose, createStore } from 'redux';
import middlewares from 'middlewares';
import getRootReducer from 'ducks';
import { initialState as metaInitialState } from 'ducks/meta';
import { getSideBarOpenPreference } from './utils/userPreferences';

const getSideBarInitialState = () => {
  try {
    const closeSideBarAtWidth = 600; //sm
    const isNotMobile =
      window.innerWidth > closeSideBarAtWidth &&
      window.outerWidth > closeSideBarAtWidth;
    return !!(isNotMobile || getSideBarOpenPreference());
  } catch (e) {
    return false;
  }
};

const getInitialState = () => {
  return {
    meta: {
      ...metaInitialState,
      isSideBarOpen: getSideBarInitialState(),
    },
  };
};

export default function configureStore() {
  // In development, use the browser's Redux dev tools extension if installed
  const enhancers = [];
  const isDevelopment = process.env.NODE_ENV === 'development';
  if (
    isDevelopment &&
    typeof window !== 'undefined' &&
    window.__REDUX_DEVTOOLS_EXTENSION__
  ) {
    enhancers.push(window.__REDUX_DEVTOOLS_EXTENSION__());
  }
  return createStore(
    getRootReducer(),
    getInitialState(),
    compose(applyMiddleware(...middlewares), ...enhancers)
  );
}
